import { Box, Skeleton } from "@mui/material";

const LocalModalSkeleton = () => {
  return (
    <Box>
      <Box className="list-group">
        <Box className="list-group-item list-group-item-action">
          <Box className="row justify-content-between g-0">
            <Box className="col">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                className="text-default"
              />
            </Box>
          </Box>
        </Box>

        <Box className="list-group-item list-group-item-action">
          <Box className="row justify-content-between g-0">
            <Box className="col">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                className="text-default"
              />
            </Box>
          </Box>
        </Box>

        <Box className="list-group-item list-group-item-action">
          <Box className="row justify-content-between g-0">
            <Box className="col">
              <Skeleton
                variant="rectangular"
                width={"100%"}
                className="text-default"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default LocalModalSkeleton;
